import React from "react";
import Logo from "../../assets/images/Asset 121.png";
import { Link, useLocation } from "react-router-dom";
import "./styles.scss";

const Navbar = ({ color }: any) => {
  const location = useLocation();
  const isActivePath = (path: string) => location.pathname === path;
  return (
    <React.Fragment>
      <nav
        className={`navbar navbar-expand-lg ftco-navbar-light fixed-top bg-${color}`}
        id="ftco-navbar"
      >
        <div className="container-fluid">
          <Link className="navbar-brand" to="/">
            <img src={Logo} className="img-fluid" alt="cci usa" />
          </Link>
          <button
            className="navbar-toggler btn"
            data-bs-toggle="collapse"
            data-bs-target="#ftco-nav"
            data-bs-auto-close="outside"
            aria-controls="ftco-nav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <i className="fa-solid fa-bars"></i>
          </button>

          <div className="collapse navbar-collapse" id="ftco-nav">
            <ul className="navbar-nav d-flex ms-auto">
              <li
                className={`nav-item ${isActivePath("/#map") ? "active" : ""}`}
              >
                <Link to="#map" className="nav-link">
                  <i className="fa-solid fa-map-pin"></i>
                  Meet and Pray
                </Link>
              </li>
              <li
                className={`nav-item ${isActivePath("/#cell-church") ? "active" : ""}`}
              >
                <Link to="#cell-church" className="nav-link">
                  <i className="fa-solid fa-church"></i>
                  <span>Cell Churches</span>
                </Link>
              </li>
              <li
                className={`nav-item ${
                  isActivePath("/#interest-groups") ? "active" : ""
                }`}
              >
                <Link to="#interest-groups" className="nav-link">
                  <i className="fa-solid fa-user-group"></i>
                  Interest Groups
                </Link>
              </li>
              <li
                className={`nav-item  ${isActivePath("/#resources") ? "active" : ""}`}
              >
                <Link to="#resources" className="nav-link">
                  <i className="fa-solid fa-circle-question"></i>
                  Resources
                </Link>
              </li>
              <li
                className={`nav-item ${
                  isActivePath("/#contact") ? "active" : ""
                }`}
              >
                <Link to="#contact" className="nav-link">
                  <i className="fa-solid fa-address-book"></i>
                  Contact us
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <div style={{marginBottom: '70px'}} />
    </React.Fragment>
  );
};

export default Navbar;
